/** Browser tab / `document.title` brand suffix (matches official styling). */
export const SITE_BRAND_TITLE = "CORRUCRAFT INDUSTRIES";

export function formatPageTitle(segment) {
  const s = String(segment || "").trim();
  if (!s) return SITE_BRAND_TITLE;
  return `${s} | ${SITE_BRAND_TITLE}`;
}
